// removed by extract-text-webpack-plugin
module.exports = {"accountPage":"WF3_2Od8DHxRduLIiSruU","pageContent":"_1S3O9mRd7x3oYTkBSjzg93","topAlign":"_2tpV6a0fOilCKgR4uwhUB3"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/accountPages/AccountPage.scss
// module id = 229
// module chunks = 0